import React from "react";
import { Breadcrumb as SemanticBreadcrumb } from "semantic-ui-react";
import "./HBreadcrumb.scss";

export const HBreadcrumb = (props) => {
  let { children, icon, ...rest } = props;

  // we can't pass both a children and icon. React will complain and say "use one or the other"
  if (children) {
    icon = null;
  } else {
    icon = icon || "right angle";
  }

  return (
    <div className="hireart-ds-breadcrumb">
      <SemanticBreadcrumb size={props.size || "small"} icon={icon}>
        {children}
      </SemanticBreadcrumb>
    </div>
  );
};

HBreadcrumb.propTypes = {};

